import { apiClient, assertOk } from "@/api/generated/client.ts"

import type { DataPointRequest } from "../types/dataPointDTOs.ts"

export const addDataPoint = async (dataPoint: DataPointRequest) => {
  const { error, response } = await apiClient.POST("/api/DataPoints", {
    body: dataPoint,
    parseAs: "text",
  })
  assertOk(response, error)
}
